import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerUser } from '../services/fetch_api';
// import '../css/Login.css';
import logo from '../assets/sustaingrowth.png';
import Popup from '../components/PopupThankYou';

const NewUser = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [message, setMessage] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = [];

    // Validação de e-mail - agora controlado manualmente.
    if (!/^[\w.-]+@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(formData.email)) {
      errors.push('Por favor, insira um e-mail válido.');
    }

    // Validação de senha.
    if (formData.password.length < 6) {
      errors.push('A senha deve ter pelo menos 6 caracteres.');
    }

    if (formData.password !== formData.confirmPassword) {
      errors.push('As senhas não coincidem.');
    }

    if (errors.length > 0) {
      setErrorMessages(errors);
      return;
    }

    try {
      // Send registration data to backend
      const response = await registerUser(formData.email, formData.password);

      // Apagar erros e mostrar mensagem de sucesso
      setErrorMessages([]);
      setMessage('Conta criada com sucesso!');
      setIsPopupOpen(true);

      // Fechar popup e redirecionar após 5 segundos
      setTimeout(() => {
        setIsPopupOpen(false);
        navigate('/login');
      }, 5000);
    } catch (error) {
      // Handle registration errors
      const backendErrors = error.response?.data?.errors || [
        error.response?.data?.message || 'Erro no registo',
      ];

      setErrorMessages(
        Array.isArray(backendErrors) ? backendErrors : [backendErrors]
      );
    }
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    navigate('/login');
  };

  // Função para verificar se a mensagem de erro contém o texto "e-mail válido".
  const hasEmailError = errorMessages.some((msg) =>
    msg.includes('e-mail válido')
  );

  return (
    <div className="body">
      <div className="wrapper">
        <div className="logo-container">
          <img className="logo" src={logo} alt="Logótipo SustainGrowth" />
        </div>
        <h2 className="h2-newuser">Registo de Novo Usuário</h2>
        <form onSubmit={handleSubmit}>
          <div className="input-box">
            <input
              type="text"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Digite o e-mail a utilizar"
              className={hasEmailError ? 'error' : ''}
            />
            <i className="fa-solid fa-envelope"></i>
          </div>
          <div className="input-box">
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Digite uma senha"
              required
              className={
                errorMessages.some((msg) => msg.includes('senha'))
                  ? 'error'
                  : ''
              }
            />
            <i className="fa-solid fa-key"></i>
          </div>
          <div className="input-box">
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Confirme a senha"
              required
              className={
                errorMessages.some((msg) => msg.includes('não coincidem'))
                  ? 'error'
                  : ''
              }
            />
            <i className="fa-solid fa-key"></i>
          </div>

          <div className="btn-container">
            <button type="submit" className="btn">
              Registrar<i className="fa-solid fa-angle-right"></i>
            </button>
            {isPopupOpen && (
              <Popup
                title="Conta Criada!"
                content={
                  <p>
                    Obrigado pelo seu registo. Ser-lhe-á enviado um email de
                    confirmação.
                  </p>
                }
                onClose={closePopup}
              />
            )}
          </div>
        </form>

        <div className="powered">
          <p>
            Powered by <a href="https://www.sfcolab.org/">SFCOLAB</a>.
          </p>
        </div>

        {message && <p className="success-message">{message}</p>}
        {errorMessages.length > 0 && (
          <ul>
            {errorMessages.map((error, index) => (
              <li key={index} className="error-message">
                {error}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default NewUser;
